import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllProgramDirector = () => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.getAllProgramDirector();
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getFilteredProgramDirector = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.getFilteredProgramDirector(page, pageSize);
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_FILTERED_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const getAllProgramDirectorByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.getAllProgramDirectorByProfileId(id);
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.GET_ALL_PROGRAM_DIRECTOR_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      })
    );
  }
};

export const insertProgramDirector = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.insertProgramDirector();
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      })
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.INSERT_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      })
    );
    return { success: false, data: null };
  }
};

export const updateProgramDirector = (id, payload) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.updateProgramDirector(id);
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.UPDATE_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      })
    );
    return false;
  }
};

export const deleteProgramDirector = (id) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.deleteProgramDirector(id);
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_SUCCESS,
      id,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.DELETE_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      })
    );
    return false;
  }
};

// Sprint 2: admin "Yêu cầu khai lại" for program director.
export const requestRevisionProgramDirector = (id, reason) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.requestRevisionProgramDirector(id);
  const { response, error } = await apiCall({ ...api, payload: { reason } });
  if (!error && response?.status === 200 && response.data?.success) {
    if (response.data.data) {
      dispatch({
        type: TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_SUCCESS,
        payload: response.data.data,
        meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
      });
    }
    dispatch(notification({ type: 'success', message: 'Đã gửi yêu cầu khai lại' }));
    return true;
  }
  dispatch(notification({
    type: 'error',
    message: response?.data?.message || 'Yêu cầu khai lại thất bại',
  }));
  return false;
};

export const acceptProgramDirector = (id, accept) => async (dispatch) => {
  const api = API_URLS.PROGRAM_DIRECTOR.acceptProgramDirector(id, accept);
  dispatch({
    type: TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_LOADING,
    meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.PROGRAM_DIRECTOR.ACCEPT_PROGRAM_DIRECTOR_FAILURE,
      meta: { prefix: [PREFIX.PROGRAM_DIRECTOR, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      })
    );
    return false;
  }
};

